function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreetLightOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    width: 44,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEADB3"
    },
    d: "M331.331,132.744v10.25h-31.347v-10.25c0-27.021-21.995-49.016-49.016-49.016 c-27.031,0-49.027,21.995-49.027,49.016v236.105h-31.347V31.347h-20.376V0h72.098v31.347h-20.376V69.13 c13.584-10.491,30.584-16.75,49.027-16.75C295.282,52.381,331.331,88.43,331.331,132.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B8892"
    },
    d: "M331.331,132.744v10.25h-31.347v-10.25c0-27.021-21.995-49.016-49.016-49.016 c-27.031,0-49.027,21.995-49.027,49.016v236.105h-15.339V0h35.715v31.347h-20.376V69.13c13.584-10.491,30.584-16.75,49.027-16.75 C295.282,52.381,331.331,88.43,331.331,132.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC473"
    },
    d: "M386.073,196.681c0,0.366-0.01,0.731-0.021,1.097v0.146l-0.282,15.391l-15.391-0.01h-39.048v17.732 h-31.347v-17.732h-54.45l-0.272-15.527c-0.01-0.366-0.021-0.731-0.021-1.097c0-38.828,31.587-70.416,70.416-70.416 S386.073,157.853,386.073,196.681z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0082D2"
    },
    points: "246.613,480.653 246.613,512 125.927,512 125.927,480.653 133.44,480.653 145.456,361.733  227.083,361.733 239.1,480.653 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#005C94"
    },
    points: "246.613,480.653 246.613,512 186.604,512 186.604,361.733 227.083,361.733 239.1,480.653 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA91F"
    },
    d: "M386.073,196.681c0,0.366-0.01,0.731-0.021,1.097v0.146l-0.282,15.391l-15.391-0.01h-39.048v17.732 h-15.673V126.265C354.486,126.265,386.073,157.853,386.073,196.681z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetLightOn);
export default __webpack_public_path__ + "static/media/street-light-on.6d529c4870b0e94baf73bc7c497a6b9f.svg";
export { ForwardRef as ReactComponent };